import React from "react";
import { Box, Button, Flex, SimpleGrid } from "@chakra-ui/react";
import ProfileText, { Variant } from "components/ProfileText";
import { ReactComponent as RocketImage } from "assets/rocket.svg";
import { Callback } from "types";

type ProfileFeild = {
  label: string;
  value?: string;
};

interface ProfileInformationProps {
  btnLabel: string;
  callback: Callback;
  feilds: ProfileFeild[];
}

const ProfileInformation: React.FC<ProfileInformationProps> = ({
  btnLabel,
  callback,
  feilds
}: ProfileInformationProps) => {
  return (
    <Flex direction={["column", "row"]} justifyContent="space-between">
      <Flex
        flexGrow={1}
        direction="column"
        alignItems={["flex-start", "center"]}
        justifyContent="space-between"
      >
        <SimpleGrid w="full" columns={[1, 3]} gap={8} whiteSpace="pre-line">
          {feilds.map(feild => (
            <ProfileText
              key={feild.label}
              label={feild.label}
              text={feild.value || ""}
              variant={Variant.SMALL}
            />
          ))}
        </SimpleGrid>
        <Button onClick={callback} mt={8} variant="blue" size="md">
          {btnLabel}
        </Button>
      </Flex>
      <Box maxW="224px" mt={[10, 0]}>
        <RocketImage width="100%" />
      </Box>
    </Flex>
  );
};

export default ProfileInformation;
